import type { Accept } from "react-dropzone";
import * as RA from "fp-ts/lib/ReadonlyArray";

import type { MimeToExt } from "@scripts/uploader/mimeTypes";

export const mimeToAccept: (mt: ReadonlyArray<MimeToExt>) => Accept =
  RA.reduce({}, (acc: Accept, x: MimeToExt) => ({ ...acc, [x.mime]: x.exts.map(_ => `.${_}`) }));
